import { z } from "zod";
import { EDocumentType } from "./partner";
import { AllowedFileExtension } from "../constants";

// Asset categories for presigned URL generation
export enum EAssetCategory {
  BANNER_IMAGE = "BANNER_IMAGE",
  BLOG_IMAGE = "BLOG_IMAGE",
  USER_PROFILE_IMG = "USER_PROFILE_IMG",
  PET_PROFILE_IMG = "PET_PROFILE_IMG",
  HEALTH_RECORD = "HEALTH_RECORD",
  PRODUCT_IMAGE = "PRODUCT_IMAGE"
}

// Presigned URL request schema
export const presignedUrlRequestSchema = z.object({
  assetCategory: z.nativeEnum(EAssetCategory, {
    errorMap: () => ({
      message: `Invalid asset category. Available options: ${Object.values(EAssetCategory).join(', ')}`
    })
  }),
  type: z.string().optional().describe('Asset type (e.g., home, shop, learn for banners)'),
});

export type IPresignedUrlRequestDto = z.infer<typeof presignedUrlRequestSchema>;

// Presigned URL response schema
export const presignedUrlResponseSchema = z.object({
  presignedUrl: z.string().describe('The presigned URL for uploading the asset'),
  key: z.string().describe('The S3 key where the asset will be stored'),
});

export type IPresignedUrlResponseDto = z.infer<typeof presignedUrlResponseSchema>;

// Image uploader component props
export interface IImageUploaderProps {
  value?: string;
  onChange: (url: string) => void;
  onError?: (error: string) => void;
  assetCategory: EAssetCategory;
  type?: string;
  maxSize?: number; // in MB
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  showPreview?: boolean;
  previewClassName?: string;
}

// Image upload state
export interface IImageUploadState {
  isUploading: boolean;
  progress: number;
  error: string | null;
  previewUrl: string | null;
}

// Image upload result
export interface IImageUploadResult {
  success: boolean;
  url?: string;
  key?: string;
  error?: string;
}

// Presigned URL Interfaces: v4
export interface IPresignedUrlRequest {
  documentType: EDocumentType;
  fileExtension: AllowedFileExtension;
}

export interface IPresignedUrlResponse {
  url: string;
  key: string;
}

// Session Document Presigned URL Interfaces
export interface ISessionPresignedUrlRequest {
  documentType: string; // ESessionDocumentType
  fileExtension: string;
}

export interface ISessionPresignedUrlResponse {
  url: string;
  key?: string;
  expiresIn?: number;
  contentType?: string;
}